import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;

  .panel-title {
    font-weight: 600;
    margin: 0.5rem 1rem;
  }

  button {
    padding: 6px 16px !important;
  }
`;

export const CommentsContent = styled.div`
  min-height: calc(100vh - 476px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Comments = styled(Flex)`
  min-height: calc(100vh - 476px);
  max-height: calc(100vh - 476px);
  overflow: auto;

  padding: 0 1.5rem 0 1rem;

  .comment {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px 0;
    border-bottom: solid var(--grey-300) 1px;
    margin-bottom: 2px;

    .title,
    .message {
      margin: 0;
    }

    img {
      cursor: pointer;
      width: 14px;
    }
  }
`;

export const CommentsInsert = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  margin-bottom: 2px;
  padding: 0 1rem;
  gap: 6px;

  textarea {
    box-sizing: border-box;
    width: 100%;
    height: 64px;
  }
`;

export const FlexContainer = styled(Flex)`
  flex: 1;
`;
